import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Divider, IconButton, MenuItem } from '@mui/material';
import { useState } from 'react';
import StyledLocalMenu from '../../common/StyledLocalMenu';

type Props = {
    onEdit: () => void;
    onChangeCategory: () => void;
    onCopyToAccount: () => void;
    copyDisabled?: boolean;
    onDelete: () => void;
};

const SextforceCaptionRowLocalMenu = (props: Props) => {
    const { onEdit, onChangeCategory, onCopyToAccount, copyDisabled, onDelete } = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const menuOpen = Boolean(anchorEl);

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const runAction = (action: () => void) => () => {
        handleMenuClose();
        action();
    };

    return (
        <>
            <IconButton size="small" onClick={handleMenuClick} sx={{ minWidth: 32, minHeight: 32 }} aria-label="Caption actions">
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <StyledLocalMenu
                id="caption-row-menu"
                MenuListProps={{
                    'aria-labelledby': 'button',
                }}
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={runAction(onEdit)} disableRipple>
                    <EditIcon />
                    Edit
                </MenuItem>
                <MenuItem onClick={runAction(onChangeCategory)} disableRipple>
                    <FolderOpenIcon />
                    Change Category
                </MenuItem>
                <MenuItem onClick={runAction(onCopyToAccount)} disabled={copyDisabled} disableRipple>
                    <ContentCopyIcon />
                    Copy to Another Account
                </MenuItem>
                <Divider />
                <MenuItem onClick={runAction(onDelete)} disableRipple>
                    <DeleteIcon color="error" />
                    Delete
                </MenuItem>
            </StyledLocalMenu>
        </>
    );
};

export default SextforceCaptionRowLocalMenu;
